import React from "react";
import { Col, Row } from "components/shared/layout";
import styled from "styled-components";
import { fonts } from "assets/fontStyles";
import colours from "assets/colours";
import Button from "components/button";

const Container = styled(Col)`
  padding: 80px 0px 45px 0px;
  max-width: 60%;
  text-align: center;
  margin: 0 auto;
  width: 638px;
  height: 280px;
  justify-content: center;
`;

const Message = styled.div`
  ${fonts.heading5};
  color: ${colours.zltoDarkBlue};
  line-height: 150%;

  span {
    color: ${colours.primary};
  }
`;

const ButtonRow = styled(Row)`
  margin-top: 30px;
  justify-content: center;
  button {
    width: 14em;
    margin: 0px 15px;
  }
`;

const IncompleteModal = ({ setShowModal }) => (
  <Container>
    <Message>All fields must be completed before submitting for Zlto.</Message>
    <ButtonRow>
      <Button variant='zltoLightBlue' onClick={() => setShowModal(null)}>Back</Button>
    </ButtonRow>
  </Container>
);

export default IncompleteModal;
